import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=34f2f15c&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=34f2f15c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f2f15c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34f2f15c')) {
      api.createRecord('34f2f15c', component.options)
    } else {
      api.reload('34f2f15c', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=34f2f15c&scoped=true&", function () {
      api.rerender('34f2f15c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2f0EW6PNm9von/JS/comp/Voucher.vue"
export default component.exports